// extracted by mini-css-extract-plugin
module.exports = {"patientNetworkFootnote":"appointments__PatientNetworkFootnote__patientNetworkFootnote"};